module.exports = __webpack_public_path__ + "media/belted-kingfisher-2.e8d16cc7.mp3";